var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgToday = function SvgToday(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Today_svg__Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 796.52 350"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Today_svg__cls-2{fill:currentColor}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m460.09 196-57-48a7.48 7.48 0 0 0-9.64 0l-57.15 47.83a7 7 0 0 0-2.5 5.34l-.1 85.06a7 7 0 0 0 7 7h31.68a7 7 0 0 0 7-7v-45a7 7 0 0 1 7-7h23.51a7 7 0 0 1 7 7l-.06 45a7 7 0 0 0 7 7h31.68a7 7 0 0 0 7-7l.11-85.06a7 7 0 0 0-2.53-5.17",
    className: "Today_svg__cls-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M313.53 193.82a4.54 4.54 0 0 1-2.9-8l84.2-69.82a4.52 4.52 0 0 1 5.75 0l85.32 69.33a4.54 4.54 0 1 1-5.73 7l-82.42-67-81.32 67.4a4.55 4.55 0 0 1-2.9 1.09",
    className: "Today_svg__cls-2"
  })));
};
export default SvgToday;